import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const mautic = defineConnector({
  identifier: "mautic",
  name: "Mautic",
  tagLine: "Open source marketing automation",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: ({ domain }) =>
    domain
      ? `https://${domain.replace(/\./g, "\\.")}/.*`
      : "https://.*.mautic..*",
  auth: (app) =>
    basicAuth({
      username: app.config.username,
      password: app.secret.password,
    }),
  steps: [
    {
      title: "Enter your Mautic instance URL",
      items: [
        {
          kind: "input",
          label: "Instance domain",
          required: true,
          placeholder: "your-mautic.example.com",
          target: { kind: "configuration", field: "domain" },
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Enter your Mautic admin username and password. See the [API docs](https://developer.mautic.org/) for details on enabling the API.",
        },
        {
          kind: "input",
          label: "Username",
          required: true,
          target: { kind: "configuration", field: "username" },
        },
        {
          kind: "input",
          label: "Password",
          required: true,
          target: { kind: "secrets", field: "password" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/api/contacts?limit=1`,
  },
});
